<template>
  <div id="order-diff-pay">
    <div class="container">
      <div class="bread">
        <router-link class="bread-item" to="/">上上签</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" to="/orders">订单管理</router-link>
        <div class="bread-arrow">&gt;</div>
        <router-link class="bread-item" :to="'/orders/detail/' + orderId">订单详情</router-link>
        <div class="bread-arrow">&gt;</div>
        <a class="bread-item">补缴费用</a>
      </div>

      <div class="page-content">
        <!-- 申请人信息 -->
        <order-applicant-infos :order="DM" :class="{'none-margin': true}" />

        <!-- 订单详情 -->
        <order-basic-info :order="DM" :peer="peer" :hidden-section="{user: true, contact: true}" />

        <!-- 补缴费用 -->
        <order-diff-info :order-diff="DM.unpaid_price_diff" v-if="DM.unpaid_price_diff"></order-diff-info>

        <!-- 余额与支付 -->
        <order-balance :order="DM" :order-diff="DM.unpaid_price_diff" :peer="peer" v-if="DM.unpaid_price_diff"></order-balance>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../libs/utils';
import Http from '../libs/http';
import User from '../libs/user';
import Order from '../libs/order';
import orderApplicantInfos from '../components/order-detail/order-applicant-infos';
import orderBasicInfo from '../components/order-detail/order-basic-info';
import orderDiffInfo from '../components/order-detail/order-diff-info';
import orderBalance from '../components/order-detail/order-balance';

export default {
  data() {
    return {
      DM: Order,
      orderId: +this.$route.params.oid,
      peer: User.peer || {},
    };
  },
  components: {
    orderApplicantInfos,
    orderBasicInfo,
    orderDiffInfo,
    orderBalance,
  },
  methods: {
    getData() {
      Http.post('/order_query', { user_order_id: this.orderId }).then((data) => {
        this.DM = data;
        utils.extend(Order, data);
      }).catch((e) => {
        if (e) console.log(e);
      });

      if (!User.peer || !User.peer.visa_peer_id) {
        Http.post('/visa_peer_query').then((data) => {
          this.peer = data;
          User.peer = data;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
#order-diff-pay {
  padding-bottom: 50px;

  & > .container {
    width: 920px;
  }

  .none-margin {
    margin-top: 0;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/OrderDiffPay.vue